<div
  class="change-password-container"
  [class.mobile]="isMobile()"
  [class.is-logged-in]="isLoggedIn"
>
  <h1>{{ i18n.langString("change_password") }}</h1>
  @if (success()) {
    <div class="toast success">
      <i
        nz-icon
        class="inline-error-icon multicolorIcon"
        nzType="icons:check-circle-filled"
      ></i>
      <span>{{ i18n.langString("changes_successful") }}</span>
    </div>
  }
  @if (error()) {
    <div class="toast error">
      <i
        nz-icon
        class="inline-error-icon fillwhite"
        nzType="icons:error-exclamation-circle"
      ></i>
      <span>{{ i18n.langString("changes_problem") }}</span>
    </div>
  }

  <app-common-form
    [formConfigureInput]="formConfiguration()"
    [submitText]="i18n.langString('change_password_submit')"
    (formSubmit)="setNewPassword($event)"
    [isAdmin]="false"
    [passwordMatchAlert]="true"
    [formType]="'forgetPassword'"
    [isSuccessful]="isSuccessfullySubmitted"
  ></app-common-form>
</div>
